var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 0c-.252 0-.477.142-.565.356L4.36 12.51c-.121.174-.186.375-.186.58 0 .602.539 1.09 1.204 1.09h6.02v9.274c0 .3.27.545.602.545.226 0 .433-.114.536-.296l7.128-12.247-.003-.003c.107-.165.164-.353.165-.545 0-.602-.54-1.09-1.204-1.09h-6.02V.544c0-.3-.27-.545-.602-.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M3.589 17.535c.494-.014.946.255 1.139.676.192.422.086.91-.269 1.229l-2.396 2.219c-.3.29-.747.406-1.167.305-.42-.101-.748-.405-.857-.794-.11-.389.016-.802.33-1.08l2.396-2.22c.217-.206.512-.327.824-.335zm16.787 0c.324 0 .633.12.859.336l2.397 2.219c.313.278.439.691.33 1.08-.11.39-.438.693-.858.794-.42.102-.866-.015-1.167-.305l-2.396-2.22c-.35-.314-.458-.794-.275-1.212.184-.419.623-.692 1.11-.692zM1.204 2c.323 0 .633.122.859.336l2.396 2.22c.313.278.44.691.33 1.08-.11.389-.437.692-.857.794-.42.101-.866-.016-1.167-.305L.368 3.905C.02 3.591-.09 3.111.094 2.693.277 2.274.716 2 1.204 2zM22.76 2c.494-.013.946.256 1.139.677.193.422.086.91-.268 1.228l-2.397 2.22c-.3.29-.747.406-1.167.305-.42-.102-.748-.405-.857-.794-.11-.389.017-.802.33-1.08l2.396-2.22c.217-.206.513-.327.824-.336z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.204,
    x2: -4.478,
    y1: 18.367,
    y2: 0.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantSetup);
export default __webpack_public_path__ + "static/media/instant-setup.72a871a942b517fa751986e34d36b972.svg";
export { ForwardRef as ReactComponent };